import { render } from "./index.vue?vue&type=template&id=168500ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=168500ea&scoped=true&lang=css"

import exportComponent from "C:\\Magang\\Digitala\\istry\\web\\frontend\\frontend-istry\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168500ea"]])

export default __exports__